"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ShapeBaseGLFilter = _interopRequireDefault(require("./ShapeBaseGLFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class ShapeGrayScaleGLFilter extends _ShapeBaseGLFilter.default {
  constructor() {
    const fsSource = `
        precision mediump float;

        varying highp vec2 v_uv;
        uniform sampler2D t_tex;
        uniform int invert;

        void main() {
            vec2 uv = v_uv;
	        uv.y = 1.0 - uv.y;
            vec4 rgba = texture2D(t_tex, uv);
            vec3 L = vec3(dot(rgba, vec4(0.21, 0.71, 0.07, 0.0)));
            if (invert == 1) {
                gl_FragColor = vec4(1.0 - L.rgb, rgba.a);
            } else  {
                gl_FragColor = vec4(L, rgba.a);
            }
        }
        `;
    super(fsSource);
    this._invert = 0;
  }

  initUniformLocations(gl, program) {
    var uniformLocations = super.initUniformLocations(gl, program);
    uniformLocations.invert = gl.getUniformLocation(program, 'invert');
    return uniformLocations;
  }

  isInverted() {
    return this._invert === 1;
  }

  willDraw(gl) {
    super.willDraw(gl);
    gl.uniform1i(this.uniformLocations.invert, this._invert);
  }

  setInverted(state) {
    this._invert = state === true ? 1 : 0;
  }

}

exports.default = ShapeGrayScaleGLFilter;